/**
 * Store complete book models (photos, backgrounds, stickers, etc...)
 */
 fx.ns("repositories", class BookRepository extends repositories.BaseRepository {

    constructor(saver, history)
    {
        super({
                creation : new models.ProductBook({id:""}), // id empty so it's not created in db
                theme : new models.Theme({id:""}),
                themetags : new repositories.ThemeTagRepository(),
                themes : new repositories.ThemesRepository(),   
                zoom : new models.Zoom(),
            }, saver, history);
    }
    
    get book()
    {
        return this.creation;
    }

    get themeid()
    {
        return this._themeid;
    }

    set themeid(val)
    {
        this._themeid = val;
    }

    get choosedCover()
    {
        return this._choosedCover;
    }

    set choosedCover(val)
    {
        this._choosedCover = val;
    }

    get choosedShape()
    {
        return this._choosedShape;
    }

    set choosedShape(val)
    {
        this._choosedShape = val;
    }

    set choosedSize(val)
    {
        this._choosedSize = val;
    }

    get choosedSize()
    {
        return this._choosedSize;
    }

    get choosedFormat()
    {
        return this._choosedFormat;
    }

    set choosedFormat(val)
    {
        this._choosedFormat = val;
    }

    /* Format / cover the editor did not ask for at creation. They are kept in the report
       json of the creation, so that reopening the album still asks for them when ordering.
       Before the creation exists they are sent to /app/create, which seeds that json. */

    get formatChoicePending()
    {
        return this.creation && this.creation.id ? !!Number(this.storedReport.format_pending) : !!this._formatChoicePending;
    }

    set formatChoicePending(val)
    {
        this._formatChoicePending = val ? 1 : 0;

        if (this.creation && this.creation.id && Number(this.storedReport.format_pending) != this._formatChoicePending)
            this.updateStoredReport({format_pending : this._formatChoicePending});
    }

    get coverChoicePending()
    {
        return this.creation && this.creation.id ? !!Number(this.storedReport.cover_pending) : !!this._coverChoicePending;
    }

    set coverChoicePending(val)
    {
        this._coverChoicePending = val ? 1 : 0;

        if (this.creation && this.creation.id && Number(this.storedReport.cover_pending) != this._coverChoicePending)
            this.updateStoredReport({cover_pending : this._coverChoicePending});
    }

    get choosedThemeTag()
    {
        return this._choosedThemeTag;
    }

    set choosedThemeTag(val)
    {
        this._choosedThemeTag = val;
    }

    get creationFormat()
    {
        let creationFormat;
        if (this.creationFormats)
        {
            for (let i = 0; i < this.creationFormats.length; i++)
                if(this.creationFormats.getItemAt(i).id === this.book.formatid)
                    creationFormat = this.creationFormats.getItemAt(i);
                
        }
        return creationFormat;
    }

    get creationFormats()
    {
        return this._creationFormats;
    }

    // Formats the album can be printed in : the ones of its shape a cover of which takes its
    // page count (see ProductBook.formatPrice). Cheapest first.
    possibleFormats()
    {
        let formats = this.availableFormats(this.creation.shape_option).filter((format) => this.creation.formatPrice(format.id) !== null);

        formats.sort((a, b) => this.creation.formatPrice(a.id) - this.creation.formatPrice(b.id));

        return formats;
    }

    // true when a possible format is larger than the current one
    get largerFormatAvailable()
    {
        let current = this.creationFormat;
        if (!current)
            return false;

        return this.possibleFormats().some((format) => format.width > current.width);
    }

    get convertPicture()
	{
		return this._convertPicture;
	}

    set convertPicture(val)
	{
		this._convertPicture = val;
	}


	get chronologicalCreator()
	{
		if (!this._chronologicalCreator)
			this._chronologicalCreator = new creators.ChronologicalCreator(this);

		return this._chronologicalCreator;
	}
    
    getBookFormat(size, shape)
    {
        for (let i = 0; i < this.creationFormats.length; i++){
            if( (this.creationFormats.getItemAt(i).style === shape) && (this.creationFormats.getItemAt(i).size == size))
                return this.creationFormats.getItemAt(i);
        };
    }

    availableFormats(shape)
    {
        let formats = [];
        if (!shape)
            shape = this.book.shape_option;

        for (let i = 0; i < this.creationFormats.length; i++)
        {
            if (this.creationFormats.getItemAt(i).style == shape)
                formats.push( this.creationFormats.getItemAt(i) )
        }

        return formats;
    }

    configurationEditable(type = "")
    {
        let formats = this.availableFormats(this.creation.shape_option);
        let covers = this.creation.availableCoverChoices(this.creation.formatid);

        let unlockConfiguration = this.creation.product && this.creation.product.id == 116;

        if (this.creation.product && this.creation.product.use_media && this.creation.product.format_id && !unlockConfiguration)
            formats = formats.filter( (format) => format.id == this.creation.product.format_id);

        if (this.creation.product && this.creation.product.use_media && this.creation.product.option_id && !unlockConfiguration)
            covers = covers.filter( (cover) => cover.option_id == this.creation.product.option_id);

        if (type == "format")
            return (formats.length > 1)
        else
        if (type == "cover")
            return (covers.length > 1)
        else
            return (formats.length > 1) || (covers.length > 1);
    }

    

    getFormatAsset(shape, size)
	{
		if (!shape)
			shape = this.creationFormat.style;

		if (!size)
			size = this.creationFormat.size;

		switch(shape)
		{
			case models.ProductBook.LANDSCAPE:
				return size == "large" ? fx.assets.sizeLandscapeLarge : fx.assets.sizeLandscapeSmall;
			break;

			case models.ProductBook.SQUARE: 
				return size == "large" ? fx.assets.sizeSquareLarge : fx.assets.sizeSquareSmall;
			break;

			case models.ProductBook.PORTRAIT:
				return size == "large" ? fx.assets.sizePortraitLarge : fx.assets.sizePortraitSmall;
			break;
		}
	}


    get iaEnabled()
    {
        return this._iaenabled || this.book.ia_project;
    }

    set iaEnabled(val)
    {
        this._iaenabled = val;
    }
 
     // ----------------------- EVENTS ----------------------- //

   

    onDataEvent(e)
    {
        super.onDataEvent(e);

        // themes of the tag found for the album loaded : the first one becomes the album's, its
        // layouts are loaded for the layouts panel (which follows "theme-tag-updated" like the
        // thematics panel makes it do)
        // the load failed : the tag is dropped, a later "themes-loaded" (the thematics panel)
        // must not apply it over the user's choice
        if (e.type == "connection-error" && this._pendingThemeTag)
            this._pendingThemeTag = null;

        if (e.type == "themes-loaded" && this._pendingThemeTag && this.themes.getThemes(this._pendingThemeTag).length)
        {
            let tag = this._pendingThemeTag;
            this._pendingThemeTag = null;

            let theme = this.themes.getFirst(tag);
            if (theme)
            {
                this.theme = theme;

                if (this.book.createdfrom != "THEMES")
                    this.book.themeid = theme.id;

                this.layouts.loadThemeLayouts(this, theme.id, true);
            }

            this.event("theme-tag-updated", tag.id);
        }
 
        // re-pagination (pages added/removed/reordered) -> recompute page labels
        if (e.type == "numbering-changed")
            this.delay(this._recomputePhotoPages, 250);

        // ----   Pagination
        if (e.type == "pagination-font-size-up")
        {
            let fontsize = this.book.pagenumbers_fontsize < 6 && this.book.pagenumbers_fontsize >= 3 ? this.book.pagenumbers_fontsize+1 : this.book.pagenumbers_fontsize;
            this.book.pagenumbers_fontsize = fontsize;
        }
        if (e.type == "pagination-font-size-down")
        {
            let fontsize = this.book.pagenumbers_fontsize <= 6 && this.book.pagenumbers_fontsize > 3 ? this.book.pagenumbers_fontsize-1 : this.book.pagenumbers_fontsize;
            this.book.pagenumbers_fontsize = fontsize;
        }
        if (e.type == "pagination-background-color")
            this.book.pagenumbers_bgcolor = e.detail;
        if (e.type == "pagination-text-color")
            this.book.pagenumbers_textcolor = e.detail;
        if (e.type == "pagination-fontfamily")
            this.book.pagenumbers_fontfamily = e.detail;
    }


    // page-number labels on photo thumbnails: photo.pagesLabel (derived, not persisted) = labels of the pages the photo is placed on; full debounced recompute on load, on placement, and on re-pagination
    checkUploadedPhotos()
    {
        let result = super.checkUploadedPhotos();   // keeps photo.number in sync
        this._recomputePhotoPages();
        return result;
    }

    onUpdated(action)
    {
        super.onUpdated(action);                     // keeps photo.number in sync via useMedia

        if (this._affectsPhotoPages(action))
            this.delay(this._recomputePhotoPages, 250);
    }

    _affectsPhotoPages(action)
    {
        let m = action.model, d = action.data;

        // add / remove / move of a photo component
        if ((action.type == "addItem" || action.type == "addItemAt" ||
             action.type == "removeItem" || action.type == "removeItemAt" ||
             action.type == "moveItem" || action.type == "moveItemAt") &&
            d instanceof models.CreationElementContent && d.isPhoto)
            return true;

        // a photo component's content / position / side / page changed, or it was deleted
        if (m instanceof models.CreationElementContent && m.isPhoto &&
            (action.impacts("content") || action.impacts("x") || action.impacts("y") ||
             action.impacts("rotation") || action.impacts("width") ||
             action.impacts("creation_element_id") || action.impacts("deleted")))
            return true;

        // a gallery photo was deleted -> its placements are removed
        if (action.type == "update" && m instanceof models.Photo && action.impacts("deleted"))
            return true;

        return false;
    }

    // how many page numbers a thumbnail label shows before "..."
    get maxPagesShown() { return 3; }


    // "Couv." / "Page 5" / "Couv., 4, 6, 8" : the cover labels first, then the page numbers
    _pagesLabel(covers, nums, single)
    {
        let parts = covers.slice();

        if (nums.length)
            parts.push(single ? fx.text("Page") + " " + nums[0] : nums.join(", "));

        return parts.join(", ");
    }


    _recomputePhotoPages()
    {
      // display-only feature: must never break load/edit -> try/catch
      try
      {
        let map = {};   // content (id or temporary id) -> { nums:[page numbers], covers:[cover labels] }

        for (let i = 0; i < this.book.elements.length; i++)
        {
            let page = this.book.elements.getItemAt(i);

            for (let j = 0; j < page.components.length; j++)
            {
                let c = page.components.getItemAt(j);

                if (!c.isPhoto || !c.content || c.deleted)
                    continue;

                let label = page.label(page.getComponentSide(c));   // "Page N" / "Couverture Face|Dos" / "" (blank side)

                if (!label)
                    continue;

                if (page.isCover)
                    label = fx.text("Couv.");   // short form on the thumbnail : face and dos collapse to one "Couv."

                let entry = map[c.content] || (map[c.content] = { nums: [], covers: [] });
                let match = page.isCover ? null : label.match(/(\d+)\s*$/);   // inner page -> keep only the number so several pages collapse to "Page 10, 20, 34"

                if (match)
                {
                    let n = parseInt(match[1], 10);
                    if (entry.nums.indexOf(n) === -1)
                        entry.nums.push(n);
                }
                else if (entry.covers.indexOf(label) === -1)
                    entry.covers.push(label);
            }
        }

        for (let i = 0; i < this.photos.length; i++)
        {
            let photo = this.photos.getItemAt(i);
            let entry = map[photo.id] || map[photo.temporaryId];   // id/temporaryId match, as in checkUploadedPhotos
            let next = "";
            let full = "";

            if (entry)
            {
                entry.nums.sort(function (a, b) { return a - b; });

                // a single placement reads as "Page 5" ; as soon as the photo is used several
                // times the tile only has room for the numbers : "Couv., 4, 6, 8..."
                let single = entry.nums.length == 1 && !entry.covers.length;
                let shown = entry.nums.length > this.maxPagesShown ? entry.nums.slice(0, this.maxPagesShown) : entry.nums;

                next = this._pagesLabel(entry.covers, shown, single) + (shown.length < entry.nums.length ? "..." : "");
                full = this._pagesLabel(entry.covers, entry.nums, single);
            }

            // strict equality -> avoids redundant updates/renders
            if ((photo.pagesLabel || "") !== next || (photo.pagesLabelFull || "") !== full)
                photo.update({ pagesLabel: next, pagesLabelFull: full }, { history: false });
        }
      }
      catch (e)
      {
        fx.log.error(e);
      }
    }


    // --------------------- LOADING / CREATING -------------------//

    initData(data)
    {
        super.initData(data);

        // TODO : test in order to fix account problem on books
        if (data.theme)
            this.theme.init( data.theme );

        if (data.themes)
            this.themes.init( data.themes );

        if (data.themetags)
            this.themetags.init(data.themetags);

        this.guests.init(data.guests);

        this.book.init(data.creation, {"CreationElement" : "ProductBookPage"});

        if (data.coverChoices)
            this.book.coverChoices.init( data.coverChoices );

        if (data.bookFormats || data.creationFormats)
            this.book.formats = data.bookFormats || data.creationFormats;

        this._creationFormats = new fx.ModelArray(data.creationFormats); // TO DO : convert to ModelArray ?
    }

    create()
    {
        let choosedCover = this.choosedCover || "standard";
        let choosedShape = this.choosedShape || "square";
        let choosedSize = this.choosedSize || "small";
        let choosedThemeTag = this.choosedThemeTag || "";

        //super.create(choosedCover, choosedShape, this.choosedFormat, choosedSize, this.themeid, this.convertPicture, choosedThemeTag);

        this.post( "/app/create", { 
                                    product_id : this.productid,
                                    cover :choosedCover, 
                                    shape : choosedShape,
                                    formatid : this.choosedFormat,
                                    size : choosedSize,
                                    themeid : this.themeid,
                                    themetagid : choosedThemeTag,
                                    project : this.convertPicture,
                                    ia : this.iaEnabled ? 1 : 0,
                                    format_pending : this._formatChoicePending || 0,
                                    cover_pending : this._coverChoicePending || 0
                                }, 
                                this.onCreateData);

        this.event("create-creation");
    }
    

    deleteBook()
    {
        this.book.deleted = 1;
        this.save();

        delete(this.book.id);
    }

    // scan all pages of a book, and check if pages are empty, or pictures are empty
    report(raw)
    {
        if (this._report && !this._needUpdateReport)
            return this._report;

        // CALCULATE IF PAGES NOT MULTIPLE OF 4 CASE
        let pagesNumber = this.book.elements.length*2-4;
        let isMultipleOf4 = ( (pagesNumber %4) == 0 ) || this.book.isLayFlat  || this.book.isSpiral;

        
        // zones : photo zones of the album, and how many hold a photo (the album check shows the share)
        this._report = { pages : [], isMultipleOf4 : isMultipleOf4, failed : false, zones : { total : 0, filled : 0 }};

        // CALCULATE PAGES WITH EMPTY PICTURES
        try {
            let numberPhotos = 0, numberPhotosEmpty = 0, PERCENTAGE_VISIBLE = 0.02;

            for (let i = 0; i < this.book.elements.length; i++)
            {
                let page = this.book.elements.getItemAt(i);
                let alreadyAdded = false;
                
                let resultPage = {page : raw ? page.id : page, components:[]};
                
                if (page.isEmpty)
                    resultPage.empty = true;
                else
                for (let j = 0; j < page.components.length; j++)
                {
                    let component = page.components.getItemAt(j);
                    let pageWidth = page.isCover ? this.book.coverWidth : this.book.pageWidth;
                    let pageHeight = page.isCover ? this.book.coverHeight : this.book.pageHeight;
                    
                    if (!component.isPhoto)
                        continue;

                    numberPhotos++;           

                    var photo = this.photos.find({id:component.content});

                    if (photo)
                    {
                        this._report.zones.filled++;
                        continue;
                    }

                    numberPhotosEmpty++;

                    let rect = fx.graphics.getBoundingRect(component, component.rotation);

                    // let's check if on backcover
                    if (page.isFirstPage && rect.x + rect.width <= pageWidth)
                            continue;

                    if (page.isLastPage && rect.x >= pageWidth)
                            continue;

                    let totalWidth = (pageWidth * (page.hasbackcover ? 1 : 2)) + (page.isCover ? this.book.sliceWidth : 0);
                    let totalHeight = pageHeight;

                    if (page.isFirstPage )
                    {
                            if (rect.x < pageWidth)
                            {
                                rect.width = rect.width - (pageWidth - rect.x);
                                rect.x = pageWidth;
                            }
                    }
                    else
                    if (page.isLastPage )
                    {
                        if (rect.x + rect.width > pageWidth)
                            rect.width = pageWidth - Math.max(0,rect.x);
                    }
                    else
                    {
                        rect.width = (rect.x + rect.width > totalWidth) ? (totalWidth - rect.x ): rect.width;
                        rect.height = (rect.y + rect.height > totalHeight) ? (totalHeight - rect.y ): rect.height;
                    }

                    // check if it's not below some other picture
                    let underComponent = false;
                    for (let k = 0; k < page.components.length; k++)
                    {
                        let othercomponent = page.components.getItemAt(k);

                        if (component.component_type != "photo" && component.component_type != "sticker")
                            continue;
    
                        if (component.id == othercomponent.id || component.level > othercomponent.level)
                            continue;
    
                        let rectOtherComponent = fx.graphics.getBoundingRect(othercomponent, component.rotation);
    
                        if (rect.x >= rectOtherComponent.x && rect.x + rect.width <= rectOtherComponent.x + rectOtherComponent.width &&
                            rect.y >= rectOtherComponent.y && rect.y + rect.height <= rectOtherComponent.y + rectOtherComponent.height)
                        {
                            underComponent = true;
                            break;
                        }
                    }
    
                    if (underComponent)
                        continue;
                    
                    // check if it intersect components
                    
                    let intersectComponents = [];
                    for (let k = 0; k < page.components.length; k++)
                    {
                        let othercomponent = page.components.getItemAt(k);
                        if (component.id == othercomponent.id || component.level > othercomponent.level)
                            continue;

                        if (component.component_type != "photo" && component.component_type != "sticker") // only stickers and photos
                            continue;


                        let rectOtherComponent = fx.graphics.getBoundingRect(othercomponent, component.rotation);

                        if ( ( (rect.x >= rectOtherComponent.x && rect.x <= rectOtherComponent.x + rectOtherComponent.width) 
                                || 
                                (rect.x <= rectOtherComponent.x && rect.x +rect.width >= rectOtherComponent.x) 
                            )
                            &&
                            (
                                (rect.y >= rectOtherComponent.y && rect.y <= rectOtherComponent.y + rectOtherComponent.height) 
                                ||
                                (rect.y <= rectOtherComponent.y && rect.y + rect.height >= rectOtherComponent.y ) 
                            )
                        )
                        {
                            intersectComponents.push( othercomponent );
                        }
                    }

                    if (intersectComponents.length > 0)
                    {
                        // check size visible
                        let visibleArea = (  ( (rect.x < 0) ? (rect.width + rect.x) : rect.width ) * ( (rect.y < 0) ? (rect.height + rect.y) : rect.height ) );
                        
                        let intersectRect = {};
                        intersectRect.x = rect.x;
                        intersectRect.y = rect.y;
                        intersectRect.width = rect.width;
                        intersectRect.height = rect.height;
                        
                        for (let k = 0; k < intersectComponents.length; k++)
                        {
                            let underComponent = intersectComponents.getItemAt(k);
                        
                            let underComponentRect = fx.graphics.getBoundingRect(underComponent, underComponent.rotation);
                            
                            if (underComponentRect.x <= rect.x && underComponentRect.x + underComponentRect.width >= rect.x && underComponentRect.x + underComponentRect.width <= rect.x + rect.width)
                            {
                                intersectRect.x = rect.x;
                                intersectRect.width = underComponentRect.x + underComponentRect.width - rect.x;
                            }

                            
                            if (underComponentRect.x >= rect.x && underComponentRect.x <= rect.x + rect.width && underComponentRect.x + underComponentRect.width >= rect.x + rect.width)
                            {
                                intersectRect.x = underComponentRect.x;
                                intersectRect.width = rect.x + rect.width - underComponentRect.x;
                            }


                            if (underComponentRect.x >= rect.x && underComponentRect.x <= rect.x + rect.width && underComponentRect.x + underComponentRect.width >= rect.x && underComponentRect.x + underComponentRect.width <= rect.x + rect.width)
                            {
                                intersectRect.x = underComponentRect.x;
                                intersectRect.width = underComponentRect.width;
                            }

                            // -----------

                            if (underComponentRect.y <= rect.y && underComponentRect.y + underComponentRect.height >= rect.y && underComponentRect.y + underComponentRect.height <= rect.y + rect.height)
                            {
                                intersectRect.y = rect.y;
                                intersectRect.height = underComponentRect.y + underComponentRect.height - rect.y;
                            }

                            if (underComponentRect.y > rect.y && underComponentRect.y < rect.y + rect.height && underComponentRect.y + underComponentRect.height >= rect.y + rect.height)
                            {
                                intersectRect.y = underComponentRect.y;
                                intersectRect.height = rect.y + rect.height - underComponentRect.y;
                            }


                            if (underComponentRect.y >= rect.y && underComponentRect.y <= rect.y + rect.height && underComponentRect.y + underComponentRect.height >= rect.y && underComponentRect.y + underComponentRect.height <= rect.y + rect.height)
                            {
                                intersectRect.y = underComponentRect.y;
                                intersectRect.height = underComponentRect.height;
                            }

                            if (intersectRect.x < 0)
                                intersectRect.x = 0;

                            if (intersectRect.y < 0)
                                intersectRect.y = 0;

                            if (intersectRect.x + intersectRect.width > totalWidth)
                                intersectRect.width = totalWidth - intersectRect.x;

                            if (intersectRect.y + intersectRect.height > totalHeight)
                                intersectRect.height = totalHeight - intersectRect.y;

                            visibleArea = Math.max(0,visibleArea - (intersectRect.width * intersectRect.height));
                        }

                        let percentageVisible = (visibleArea / (totalWidth * totalHeight));
                        
                        if (percentageVisible <= PERCENTAGE_VISIBLE)
                            continue;
                    }

                    // check if percentage visible is lower than 5%
                    let mainPercentageVisible = (  ( (rect.x < 0) ? (rect.width + rect.x) : rect.width ) * ( (rect.y < 0) ? (rect.height + rect.y) : rect.height ) ) / (totalWidth * totalHeight);

                    if (mainPercentageVisible < PERCENTAGE_VISIBLE)
                        continue;

                    if (!alreadyAdded)
                    {
                        resultPage.components.push(raw ? component.id : component);

                        alreadyAdded = true;
                    }
                }

                if (resultPage.empty || resultPage.components.length > 0)
                    this._report.pages.push( resultPage );
            }

        } 
        catch(e)
        {
            fx.log.error(e);
        }

        this._needUpdateReport = false;

        this._report.failed = this._report.pages.length > 0 || !this._report.isMultipleOf4;

        // the empty zones reported, the ones hidden under another photo left out
        for (let i = 0; i < this._report.pages.length; i++)
            this._report.zones.total += this._report.pages[i].components.length;
        this._report.zones.total += this._report.zones.filled;

        return this._report;
    };


    createCustomLayout(page, side)
    {
        this.on("thumb-generated", this._onThumbGenerated, fx.service("ThumbGenerator"))
        fx.service("ThumbGenerator").generate(this.book, page, side); 
    }

    _onThumbGenerated(event)
    {
        this.off("thumb-generated", this._onThumbGenerated, fx.service("ThumbGenerator"))

        let thumb = event.detail.thumb;
        let page = event.detail.element;
        let side = event.detail.side;
        
        this.layouts.createCustomLayout(page, side, thumb, this.book.pageWidth, this.book.pageHeight, this.book.sliceWidth, this.book.shape_option, this.account.id); 
    }

   

    loadBookFormats()
    {
        if (this._creationFormats)
            this._creationFormatsLoaded();
        else
            this.post( "/app/creationformats", { productid : this.productid },  this._creationFormatsLoaded);
    }

    _creationFormatsLoaded(data)
    {
        if (this._creationFormats)
            this.event("book-format-loaded");
        else
        if (data.error)
            this.event("book-format-error", data);
        else
        {
            this._creationFormats = new fx.ModelArray(data);
            this.event("book-format-loaded");
        }
    }


    getThemeTags()
    {
        if (this.themetags && this.themetags.length > 0)
            this.event("theme-tags-loaded");
        else
            this.post( 
                "/app/themes",
                { 
                    action:"tags",
                    id_lang : fx.service("LangService").current.id
               }, 
               this._getThemeTags);
    }

    _getThemeTags(data)
    {
        if (data.error)
        {
            this.event("connection-error", data);
        }
        else
        {
            this.themetags.init(data);
            this.event("theme-tags-loaded");
        }
    }

    // ---------- Config : create layouts from pages

    storeUpdatedPages()
    {
        this._pagesModified = this.book.pages.filter( page => page.modified);
    }

    saveLayouts()
    {
        this.post("/app/layouts", {action : "savelayouts", bookid : this.book.id}, this._layoutsSaved);
    }

    _layoutsSaved(data)
    {
        if (data.error)
            this.event("save-layouts-error", data);
        else
            this.event("layouts-saved");
    }

    saveLayoutThumbs()
    {
        this.on("ready", this._onLayoutThumbsReady, fx.service("ThemeThumbGenerator"));
        fx.service("ThemeThumbGenerator").generate(this.book, this._pagesModified);
    }
       
    _onLayoutThumbsReady(event)
    {
        this.off("ready", this._onLayoutThumbsReady, fx.service("ThemeThumbGenerator"));

        if (event.detail.length > 0)
        {
            var data = {};
            data.creationid = this.book.id;
            data.accountid = this.account.id;
            data.id_lang = fx.service("LangService").current.id,
            data.platform = "desktop";
            data.thumbs = event.detail;
            data.width = this.book.pageWidth ;
            data.height = this.book.pageHeight ;
            data.slice = this.book.sliceWidth ;
            data.action = "savethumblayouts";
            this.post("/app/layouts", data, this._saveLayoutThumbs, {timeout : 0});
        }
        else
            this.event("thumb-layouts-saved", data);    
    }
       

    _saveLayoutThumbs(data)
    {
        if (data.error)
            this.event("thumb-layouts-saved-error", data);
        else
            this.event("thumb-layouts-saved", data);    
    }


    // -- Album category

    /** The theme tag (models.ThemeTag) the automatic creation recognised for the album, if any. */
    get themeTagDetected()
    {
        return this._themeTagDetected || null;
    }

    /**
     * Loads the themes of a tag (a models.ThemeTag, its id or its folder) in place of the current
     * ones : the album takes the first theme and its layouts, the layouts panel follows.
     */
    applyThemeTag(tag)
    {
        if (!(tag instanceof models.ThemeTag) && this.themetags && this.themetags.find)
            tag = this.themetags.find({ folder : tag }) || this.themetags.find({ id : tag });

        if (!tag || !(tag instanceof models.ThemeTag))
            return;

        this._themeTagDetected = tag;
        this._pendingThemeTag = tag;

        this.themes.load(tag, true, fx.currentLang());
    }

    /**
     * The album category detected by the TitleSuggester, stored in the report of the creation so
     * that the album opened again follows it : { folder, theme_tag_id, points }, null when none.
     */
    get albumCategory()
    {
        let category = this.storedReport.album_category;

        return (category && category.folder) ? category : null;
    }

    /**
     * Only a product without theme (use_media 0) follows a detected category : a collection product
     * keeps its own covers, backgrounds and stickers.
     */
    get followsAlbumCategory()
    {
        let product = this.book ? this.book.product : null;

        return !!product && Number(product.use_media) == 0;
    }

    /**
     * The category the TitleSuggester has just detected (magic.TitleStep) : info = { folder,
     * themetag, covers : { category, points } }. Stored in the creation, then applied (applyAlbumCategory).
     */
    detectAlbumCategory(info)
    {
        if (!info || !info.folder || !this.followsAlbumCategory)
            return;

        let tag = info.themetag || null;
        let covers = info.covers || { category : info.folder, points : [] };

        let category = { folder : info.folder, theme_tag_id : tag ? tag.id : 0, points : covers.points || [] };

        this.updateStoredReport({ album_category : category });
        this.applyAlbumCategory(category);
    }

    /** The album opened again : the category it was built with, when it has one. */
    restoreAlbumCategory()
    {
        if (this.albumCategory && this.followsAlbumCategory)
            this.applyAlbumCategory(this.albumCategory, true);
    }

    /**
     * Follows an album category : the covers naming the place of the photos then those of the
     * category are offered in the layouts panel (LayoutsRepository.loadProposedCovers), and when
     * the category is not the one of the album's theme (creation.theme.theme_tag_id), the
     * recommended backgrounds and stickers are those of the category. The server reads the stored
     * category as well, so an album opened again gets them from its first load : `reopened` only
     * keeps them for the next pages of the panels.
     */
    applyAlbumCategory(category, reopened)
    {
        if (!category || !this.layouts)
            return;

        this.layouts.loadProposedCovers({ category : category.folder, points : category.points || [] }, this.book.shape_option);

        let tagId = Number(category.theme_tag_id) || 0;
        let themeTagId = this.theme ? Number(this.theme.theme_tag_id) || 0 : 0;

        if (!tagId)
            return;

        for (let repository of [this.backgrounds, this.stickers])
        {
            if (!repository || !repository.reloadRecommended)
                continue;

            if (reopened || tagId == themeTagId)
                repository.themeTagId = tagId;
            else
                repository.reloadRecommended(this.book, tagId);
        }
    }

    /**
     * A collection product (use_media) : its covers naming where the photos of the album were taken
     * are listed first in the layouts panel (LayoutsRepository.matchPlaceCovers). Run when the album
     * is opened ; the automatic creation runs it itself when it picks the cover.
     */
    rankCoversByPlace()
    {
        let product = this.book ? this.book.product : null;

        if (!product || !Number(product.use_media) || !this.layouts || !this.photos)
            return;

        let ids = this.layouts.filter((layout) => layout.product_id == product.id && layout.target == "cover").map((layout) => layout.id);
        let points = [];

        try
        {
            let suggester = fx.service("TitleSuggester");
            points = suggester.coverPoints(suggester.context(this.photos.active));
        }
        catch (e) {}

        this.layouts.matchPlaceCovers(ids, points);
    }

    // -- Placing photos

    // Answers a Promise : the creator curates the photos in the browser before placing them
    // options : { title } for the cover, { showDates : false } to hide the day labels (shown whenever the photos span several days)
    placePhotosChronologically(photos, options)
	{
		this.placing = true;

		let done = () => { this.placing = false; };
		let result = this.chronologicalCreator.placePhotos(photos, options);

		if (result && typeof result.then == "function")
			return result.then(done, done);

		done();

		return Promise.resolve();
	}


    /*forceSaving()
    {
        if (this._forceSaving)
            return;

        this._forceSaving = true;

        this.saver.cancel();

        let medias = [];
        for(let i = 0; i < this.photos.length; i++)
        {
            let photo = this.photos.getItemAt(i);
            medias.push({id : photo.id, mediatype : "photo", number : photo.number, deleted : photo.deleted});
        }
        
        let data = { 
                        action:"forcesave", 
                        id : this.book.id,
                        pages : this.book.elements.JSON(),
                        medias : medias
                    };

        if (data.pages.length != this.book.elements.length)
            this._onForceSave({});
        else
        {
            if (!this._onForceSaveHandler)
                this._onForceSaveHandler = this._onForceSave.bind(this);

            this.saver.post( "/app/forcesave", data, this._onForceSaveHandler);
        }
    }

    _onForceSave(data)
    {
        this.saving = false;
        this._forceSaving = false;

        if (!data.error)
        {
            for (let i = 0; i < this.book.elements.length; i++)
            {
                let page = this.book.elements.getItemAt(i);
                let pageData = data[page.id]
                if (pageData)
                {
                    page.id = pageData.id;

                    for (let j = 0; j < page.components.length; j++)
                    {
                        let component = page.components.getItemAt(j);

                        if (pageData.components[component.id])
                            component.id = pageData.components[component.id].id;
                    }
                }
            }

            this.saver.reset(true);

            this.event("creation-saved");
        }
        else
        {
            this.saver.reset();

            this.event("save-book-error", data);
        }  
    }*/

});